import ArachnaApi from "./requests/arachna-api";
export default (config) => {
    const request = ArachnaApi.getInstance().request;
    return request.get(`/posts/${config === null || config === void 0 ? void 0 : config.postId}`, {
        params: Object.assign({}, config === null || config === void 0 ? void 0 : config.params),
        headers: Object.assign({}, config === null || config === void 0 ? void 0 : config.headers)
    });
};
